function getQueryParams(url) {
  const params = {};
  // 如果没传 url，默认取当前页面地址
  const targetUrl = url || window.location.href;

  const queryString = targetUrl.split('?')[1];
  if (!queryString) return params;

  queryString.split('&').forEach(item => {
    if (!item) return;
    const [key, value] = item.split('=');
    params[decodeURIComponent(key)] = decodeURIComponent(value || '');
  });

  return params;
}
function getCurDeviceInfo() {
  var currentDevice = device.getAppDevice();
  var currentSocial =
    device.getSocial() ||
    localStorage.getItem('social') ||
    'web';

  var currentAppname =
    device.getAppName() ||
    localStorage.getItem('appname') ||
    'com.huami.webapp';

  var currentAppVersion = device.getMifitVersion(currentDevice);

  return {
    currentAppVersion: currentAppVersion,
    currentDevice: currentDevice,
    currentSocial: currentSocial,
    currentAppname: currentAppname
  };
}

function getToken(ka) {
  var deviceInfo = getCurDeviceInfo();
  var currentSocial = deviceInfo.currentSocial;
  var currentAppname = deviceInfo.currentAppname;

  return new Promise(function (resolve, reject) {
    console.log(isInApp(), 'isInApp()');

    if (isInApp()) {
      ka.ready().then(
        function (res) {
          console.log('==== ka init ====', res);
          localStorage.setItem('uid', res.key);

          var headers = {
            'X-Param-Aid': res.app_key || '',
            'X-Param-Social': currentSocial,
            appname: currentAppname,
            apptoken: res.token
          };

          var rdata = {};
          // Object.assign 的 ES5 写法
          for (var k in res) {
            if (res.hasOwnProperty(k)) {
              rdata[k] = res[k];
            }
          }

          rdata.uid = res.key;
          rdata.headers = res.access_token
            ? (function () {
                var h = {};
                for (var key in headers) {
                  if (headers.hasOwnProperty(key)) {
                    h[key] = headers[key];
                  }
                }
                h.Authorization = res.access_token;
                return h;
              })()
            : headers;

          console.log(
            'uid-----',
            rdata.uid,
            'aid---',
            rdata.app_key,
            'token----',
            rdata.token
          );

          resolve(rdata);
        },
        function (err) {
          reject(err);
        }
      )
    } else {
      console.log('app外');
      resolve({});
    }
  });
}

function isInApp() {
  var d = getCurDeviceInfo().currentDevice;
  var apps = ['mi', 'midong', 'amazfit', 'zepp', 'timex', 'bell'];
  return apps.indexOf(d) !== -1;
}

/**
 * 显示半透明 Toast
 * @param {string} text 提示内容
 * @param {number} duration 持续时间（毫秒），默认 3000ms
 */
function showToast(text, duration) {
    var displayTime = duration || 3000;
    
    // 查找或创建 toast 元素
    var toast = document.getElementById('hm-toast-container');
    if (!toast) {
        toast = document.createElement('div');
        toast.id = 'hm-toast-container';
        toast.className = 'hm-toast';
        document.body.appendChild(toast);
    }

    // 设置内容并显示
    toast.textContent = text;
    toast.classList.add('show');

    // 如果已经有定时器，先清除
    if (toast._timer) {
        clearTimeout(toast._timer);
    }

    // 自动消失
    toast._timer = setTimeout(function() {
        toast.classList.remove('show');
        toast._timer = null;
    }, displayTime);
}

// 挂载到 window 方便全局调用
window.showToast = showToast;

function checkNetworkAndToast() {
  if (typeof navigator !== "undefined" && !navigator.onLine) {
    if (typeof showToast === "function") {
      showToast("Network connection error.");
    } 
    return false; // 网络不通
  }
  return true; // 网络正常
}

window.checkNetworkAndToast = checkNetworkAndToast;